import React from 'react';
import DefaultBotMessage from '../components/botMessages/DefaultBotMessage';
export const WhatDoYouNeedHelpWith = () => React.createElement(DefaultBotMessage, { translationKey: 'helpbot.questions.whatDoYouNeedHelpWith' });
export const SelectSupportChannelBotMessage = () => React.createElement(DefaultBotMessage, { translationKey: 'helpbot.questions.selectSupportChannel' });
export const ThatHelpedBotMessage = () => React.createElement(DefaultBotMessage, { translationKey: 'helpbot.questions.thatHelped' });
